import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import BadgeCollect from './BadgeCollect';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as animationHelper from "../../../helpers/animationHelper";

class AwardBadge extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            status: objectConstants.STATUS_NOT_STARTED,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            bite_id: this.props.callbacks.getBiteId(),
            badgeUserData: this.props.badgeUserData,
            locale: appHelper.getLocalData(this.props.screenObject),
            badges: appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", this.props.callbacks.getBiteId()).badges,
            showAchieved: false,
            screenStatus: "",
            checkComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            progressionHandled: false,
            continue_label: appHelper.getLocaleString("continue_label")
        };

        this.show = this.show.bind(this);
        this.getUserBadge = this.getUserBadge.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onCollected = this.onCollected.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);

        this.badgeRef = React.createRef();
    }

    componentDidMount() {
        this.show();
        this.getScreenStatus();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            lang: nextProps.lang,
            locale: appHelper.getLocalData(this.state.screenObject),
            continue_label: appHelper.getLocaleString("continue_label")
        });

    }


    componentDidUpdate() {
        if (this.state.checkComplete) {
            this.onComplete();
        }

    }
    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let object = this.refs[`award_badge`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(object.offsetTop, true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    getUserBadge(badge) {
        return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.onComplete();
        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            }
        }

    }


    onObjectComplete(kpi) {
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "kpi_id", kpi.kpi_id);
        if (index === -1) {
            this.setState(
                {
                    completeObjects: dataHelper.immutablePush(this.state.completeObjects, kpi),
                    status: objectConstants.STATUS_IN_PROGRESS
                }
            );
        }
    }

    onComplete() {
        //console.log('onComplete');
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
            if (!hasNextObject) {
                this.handleProgression();
                this.enableProgression();
            } else {
                this.enableProgression();
            }

        } else {
            this.handleProgression();
        }
        this.scrollToTop();
    }

    onCollected(){
        this.setState({checkComplete: true, status: objectConstants.STATUS_COMPLETE});
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    handleProgression() {

        if(!this.state.progressionHandled) {
            this.setState({progressionHandled: true});
            let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
            let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
                index: this.props.index
            };

            this.props.callbacks.onObjectComplete(completionData);
        }
    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index)) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    show() {
        let badgeRef = this.badgeRef.current;

        if(appHelper.isObjectEleDefined(badgeRef)) {
            let params = {
                ele: badgeRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.getObjectStatus
            };
            animationHelper.showHeight(params);
        }
    }

    render() {

        return (
            <div className="a-c" ref={this.badgeRef}>
                <div className={`object-container`}>
                    <BadgeCollect badge_id={this.state.screenObject.badge_id} bite_id={this.props.callbacks.getBiteId()} asset_id={this.state.screenObject.asset_id} onCollected={this.onCollected}/>
                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>
        );
    }
}

AwardBadge.propTypes = {
    screenObject: PropTypes.object.isRequired,
    badgeUserData: PropTypes.array.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    trackingData: PropTypes.object
};

AwardBadge.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData,
        trackingData: state.trackingData,
        badgeUserData: state.userData.badges

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AwardBadge);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/AwardBadge.js
 **/